import React from 'react';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import CircleStackIcon from '@heroicons/react/24/outline/CircleStackIcon';
import ChevronDownIcon from '@heroicons/react/24/outline/ChevronDownIcon';
import ChevronRightIcon from '@heroicons/react/24/outline/ChevronRightIcon';
import { useIsMobile } from '../hooks/use-is-mobile';

export function StatusFilterButton({ label, onClick, sx }) {
  const isMobile = useIsMobile();

  const button = (
    <Button
      variant="outlined"
      startIcon={
        <SvgIcon fontSize="small">
          <CircleStackIcon />
        </SvgIcon>
      }
      endIcon={
        <SvgIcon fontSize="small">
          <ChevronDownIcon />
        </SvgIcon>
      }
      onClick={onClick}
      sx={{
        minWidth: 160,
        maxWidth: 500,
        justifyContent: 'space-between',
        ...(isMobile && { flex: 1, minWidth: 0, height: 40, borderRadius: 999, bgcolor: 'background.paper' }),
        ...sx,
      }}
    >
      {label}
    </Button>
  );

  if (isMobile) {
    return button;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography color="primary" variant="caption" sx={{ fontSize: 18 }}>
        Filter by Status
      </Typography>
      <SvgIcon fontSize="small">
        <ChevronRightIcon />
      </SvgIcon>
      {button}
    </Box>
  );
}
